import { makeAutoObservable } from "mobx";
import {
  pagingRegimens,
  getRegimen,
  createRegimen,
  editRegimen,
  deleteRegimen,
  checkCode,
} from "./RegimenService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { getByConfigKey } from "../SystemConfig/SystemConfigService";
import LocalConstants from "app/LocalConstants";

const initSearchObject = {
  key: "",
  type: null,
  shortTerm: null,
  customRegimen: null,
  sortName: null,//sort tên
  sortCode: null,//sort mã
  sortType: null,//loại phác đồ
  sortTerm: null,//thời gian
  isCurrentlyUsing: null,
}

export default class RegimenStore {
  regimenList = [];
  selectedRegimen = null;
  selectedRegimenList = [];
  totalElements = 0;
  customRegimen = false;
  type = 0;
  shortTerm = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  text = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  openPopup= false;
  isCheck = false;
  searchObject = {...initSearchObject}
  initSearchObject = {...initSearchObject}
  listNumberDays = [...Array(LocalConstants.SYSTEM_CONFIG_DEFAULT_NUMBER_DAYS)
    .map((_, i) => ({ value: (i + 1), name: `${(i + 1)}/${LocalConstants.SYSTEM_CONFIG_DEFAULT_NUMBER_DAYS}` }))];

  constructor() {
    makeAutoObservable(this);
  }

  setOpenPopup= state =>{
    this.openPopup = state;
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    var newSearchObject = {};
    newSearchObject.keyword = this.text;
    newSearchObject.shortTerm = this.searchObject.shortTerm;
    newSearchObject.customRegimen = this.searchObject.customRegimen;
    newSearchObject.type = this.searchObject.type;
    newSearchObject.sortName = this.searchObject.sortName;
    newSearchObject.sortCode = this.searchObject.sortCode;
    newSearchObject.sortType = this.searchObject.sortType;
    newSearchObject.sortTerm = this.searchObject.sortTerm;
    newSearchObject.isCurrentlyUsing = this.searchObject.isCurrentlyUsing;

    newSearchObject.pageIndex = this.page;
    newSearchObject.pageSize = this.rowsPerPage;
    if (item != null) {
      this.page = 1;
      this.text = item.keyword;
      newSearchObject.pageIndex = 1;
      // searchObject.pageSize = 10;
      newSearchObject.keyword = this.text;
      this.search(newSearchObject);
    } else {
      newSearchObject.keyword = this.text;
      this.search(newSearchObject);
    }
  };

  search = async (searchObject) => {
    this.loadingInitial = true;
    try {
      let data = await pagingRegimens(searchObject);
      this.regimenList = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };
  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = item;
  }
  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditRegimen = (id) => {
    this.getRegimen(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.updatePageData();
  };

  handleDelete = (id) => {
    this.getRegimen(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = () => {
    this.deleteRegimen(this.selectedRegimen.id);
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedRegimenList.length; i++) {
      try {
        await deleteRegimen(this.selectedRegimenList[i].id);
      } catch (error) {
        listAlert.push(this.selectedRegimenList[i].name);
        console.log(error);
        console.log(listAlert.toString());
        toast.warning("toast.delete_fail");
      }
    }
    this.handleClose();
    toast.success("Đã xóa thành công!");
  };

  handleSelectRegimen = (regimen) => {
    this.selectedRegimen = regimen;
  };

  handleSelectListRegimen = (regimens) => {
    this.selectedRegimenList = regimens;
  };

  getRegimen = async (id) => {
    // console.log(id)
    if (id != null) {
      try {
        let data = await getRegimen(id);

        this.handleSelectRegimen(data.data);

      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectRegimen(null);
    }
  };

  createRegimen = async (regimen) => {
    try {
      let responseCheckCode = await checkCode(regimen);
      if (responseCheckCode.data) {
        toast.warning("Mã đã được sử dụng!");
      } else if (this.isCheck === true) {
        toast.warning("Trùng thuốc!");
      } else {
        await createRegimen(regimen);
        toast.success("Thêm mới thành công!");
        this.handleClose();
      }
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi thêm mới!");
    }
  };

  editRegimen = async (regimen) => {
    try {
      let responseCheckCode = await checkCode(regimen);
      if (responseCheckCode.data) {
        toast.warning("Mã đã được sử dụng!");
      } else if (this.isCheck === true) {
        toast.warning("Trùng thuốc!");
      } else {
        await editRegimen(regimen);
        toast.success("Cập nhật thành công!");
        this.handleClose();
      }

    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  deleteRegimen = async (id) => {
    try {
      const res = await deleteRegimen(id);
      if (res?.data) {
        toast.success("Đã xoá bản ghi");
      } else {
        toast.warning("Không thể xoá vì có dữ liệu ràng buộc");
      }
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
    }
  };
  checkValidateMedications = (medications) => {
    this.isCheck = false;
    //console.log(medications);
    for (var i = 0; i < medications.length; i++) {
      for (var j = i + 1; j < medications.length; j++) {
        if (medications[i]?.medication?.id === medications[j]?.medication?.id &&
          medications[i]?.period?.id === medications[j]?.period?.id) {
          this.isCheck = true;
        }
      }
    }
    //console.log(this.isCheck);
  };

  getNumberDays = () => {
    getByConfigKey(LocalConstants.SYSTEM_CONFIG_NUMBER_DAYS).then(({ data }) => {
      if (data?.configValue) {
        let value = Number.parseInt(data.configValue);
        if (!Number.isNaN(value)) {
          // value = LocalConstants.SYSTEM_CONFIG_DEFAULT_NUMBER_DAYS;
          let list = [];
          for (let i = 0; i < value; i++) {
            let count = i + 1;
            list.push({ value: count, name: `${count}/${value}` })
          }
          this.listNumberDays = [...list]
        }
      }
    }).catch((e) => {
      console.log(e);
    })
  }
  resetSearchObject = () => {
    this.searchObject = {
      type: null,
      shortTerm: null,
      customRegimen: null,
      sortName: null,//sort tên
      sortCode: null,//sort mã
      sortType: null,//loại phác đồ
      sortTerm: null,//thời gian
    }
    this.text = "";
    this.page = 1;
    this.rowsPerPage = 10;
  }

  preHandleSubmitData = (values) => {
    return {
      ...values,
      code: values?.code?.trim(),
      name: values?.name?.trim(),
    }
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortName: null,//sort tên
      sortCode: null,//sort mã
      sortType: null,//loại phác đồ
      sortTerm: null,//thời gian
      ...item,
    };
    this.updatePageData();
  }
}
